import { render, staticRenderFns } from "./IndexAssignations.vue?vue&type=template&id=f76346f6&scoped=true"
import script from "./IndexAssignations.vue?vue&type=script&lang=js"
export * from "./IndexAssignations.vue?vue&type=script&lang=js"
import style0 from "./IndexAssignations.vue?vue&type=style&index=0&id=f76346f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76346f6",
  null
  
)

export default component.exports